<template>
  <b-row class="mb-4">
    <!-- Card Atendimento -->
    <b-col
      cols="12"
      lg="6"
      class="mb-4"
    >
      <b-card class="h-100">
        <template #header>
          <div class="d-flex align-items-center">
            <feather-icon
              icon="MessageSquareIcon"
              size="20"
              class="text-success mr-2"
            />
            <h4 class="mb-0">
              Atendimento
            </h4>
          </div>
        </template>

        <b-row>
          <b-col cols="6">
            <div class="text-center">
              <div class="avatar bg-light-warning p-50 mx-auto mb-2">
                <feather-icon
                  icon="ClockIcon"
                  size="24"
                  class="text-warning"
                />
              </div>
              <h3 class="font-weight-bolder mb-1">
                {{ estatisticas.tempoMedioResposta }}
              </h3>
              <p class="card-text text-muted mb-0">
                Tempo Economizado
              </p>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="text-center">
              <div class="avatar bg-light-success p-50 mx-auto mb-2">
                <feather-icon
                  icon="UsersIcon"
                  size="24"
                  class="text-success"
                />
              </div>
              <h3 class="font-weight-bolder mb-1">
                {{ estatisticas.totalConversas }}
              </h3>
              <p class="card-text text-muted mb-0">
                Total de Atendimentos
              </p>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

    <!-- Card Vendas de Incentivo/Recompra -->
    <b-col
      cols="12"
      lg="6"
      class="mb-4"
    >
      <b-card class="h-100">
        <template #header>
          <div class="d-flex align-items-center">
            <feather-icon
              icon="ShoppingCartIcon"
              size="20"
              class="text-primary mr-2"
            />
            <h4 class="mb-0">
              Vendas de Incentivo/Recompra
            </h4>
          </div>
        </template>

        <b-row>
          <b-col cols="6">
            <div class="text-center">
              <div class="avatar bg-light-primary p-50 mx-auto mb-2">
                <feather-icon
                  icon="DollarSignIcon"
                  size="24"
                  class="text-primary"
                />
              </div>
              <h3 class="font-weight-bolder mb-1">
                R$ {{ formatarMoeda(estatisticas.receitaTotalIncentivada) }}
              </h3>
              <p class="card-text text-muted mb-0">
                Receita Total Incentivada
              </p>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="text-center">
              <div class="avatar bg-light-info p-50 mx-auto mb-2">
                <feather-icon
                  icon="TrendingUpIcon"
                  size="24"
                  class="text-info"
                />
              </div>
              <h3 class="font-weight-bolder mb-1">
                {{ estatisticas.taxaConversao }}%
              </h3>
              <p class="card-text text-muted mb-0">
                Taxa de Conversão
              </p>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard,
} from 'bootstrap-vue'

export default {
  name: 'DashboardStats',
  components: {
    BRow,
    BCol,
    BCard,
  },
  props: {
    estatisticas: {
      type: Object,
      required: true,
      default: () => ({
        tempoMedioResposta: '0h 0m',
        totalConversas: 0,
        receitaTotalIncentivada: 0,
        taxaConversao: 0,
      }),
    },
  },
  methods: {
    formatarMoeda(valor) {
      if (!valor) return '0,00'
      return Number(valor).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
  },
}
</script>
